import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  swiper: {
    display: "block",
    minWidth: "100%",
    maxWidth: "300px",
    objectFit: "cover",
  },
  swiperSlide: {
    textAlign: "center",
    fontSize: "18px",
    objectFit: "contain",
    display: "flex",
    justifyContent: "center ",
    alignItems: "center",

  },
  media: {
    width: "100%",
    height: "100%",
  }
}))

export default useStyles;